Mmg.addShortcode(

  /**
   *
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'property_search',
  '.sc-property-search',

  /**
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {
    const $stickyTarget = $(model.stickyTarget);
    const breakpoint = $.breakpoint('get');

    // Widget Declarations
    const $this = $(el);
    const $formSection = $this.find(`${selector}__form-section`);

    // Form elements
    const $form = $(`${selector}__form`);
    const $locationInput = $form.find(`${selector}__location-input`);
    const $moveInInput = $form.find('[name="move-in-date"]');
    const $moveOutInput = $form.find('[name="move-out-date"]');
    const $dateGroup = $(`${selector}__date-group`);
    const $submitButton = $form.find(`${selector}__button`);
    const searchBaseUrl = "https://www.housestay.com/search/";
    let city = model.city;
    let state = model.state;
    let latitude = model.latitude;
    let longitude = model.longitude;
    const minDate = moment().add(2, 'days').format("YYYY-MM-DD");
    const defaultOutDate = moment().add(32, 'days').format("YYYY-MM-DD");


    /**
     * Initialize the widget
     */
    (function init() {
      initTypeAhead();
      addEvents();
      makeSticky();
      setLocation({city, state, latitude, longitude});
      setMinDates();
    })();


    /**
     * Handle events in the UI
     */
    function addEvents() {
      $dateGroup.one('change', handleDateChange);
      $moveInInput.on('change', handleCheckOut);
      $form.on('submit', submitForm);
    }


    /**
     * Handle Changes to the date group.
     * @param {*} event 
     */
    function handleDateChange(event) {
      const $el = $(event.currentTarget);
      const $label = $el.find('label');
      const $input = $el.find('input');

      if (['xs', 'sm'].includes(breakpoint.size)) {
        return;
      }

      $label.hide();
      $input.css({opacity: 1});
    }

    function setMinDates() {
      $moveInInput.attr('min', minDate);
      $moveOutInput.attr('min', defaultOutDate);
    }

    /**
     * After check in date submitted
     * Set values and minimums for Check Out
     */
    function handleCheckOut() {
      const minOutDate = moment($moveInInput.val()).add(30, 'days').format('YYYY-MM-DD');

      $moveOutInput.attr('min', minOutDate);

      if (minOutDate > $moveOutInput.val()) {
        $moveOutInput.val(minOutDate);
      }
    }


    /**
     * Make the form sticky when scrolled off screen
     */
    function makeSticky() {
      const intersectCallback = ([e]) => {
        const offscreen = (e.boundingClientRect.height + e.boundingClientRect.top) < 0;

        handlePosition(offscreen);

        $form[0].toggleAttribute('stuck', offscreen);
      }

      new IntersectionObserver( 
        intersectCallback,
        { threshold: [0, 1] }
      ).observe($formSection[0]);
    }

    /**
     * Adjust the form position 
     */
    function handlePosition(offscreen) {
      let positionTarget = $formSection;

      if (offscreen) {
        positionTarget = $stickyTarget;
      }

      $form.appendTo(positionTarget);
    };


    /**
     * Initialize type ahead
     */
    function initTypeAhead() {
      const endpoint = `${model.apiUrl}`;
      const bloodhoundSuggestions = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: endpoint + '?q=%QUERY',
          wildcard: '%QUERY'
        }
      });

      $locationInput.typeahead({
        hint: true,
        highlight: true,
        minLength: 3,
      },
      {
        name: 'suggestions',
        display: function(suggestion) {
          return `${suggestion.city}, ${suggestion.state}`;
        },
        source: bloodhoundSuggestions,
      });

      $locationInput.on('typeahead:select', function(event, suggestion){
        setLocation(suggestion);
      })

      return bloodhoundSuggestions;
    }


    /**
     * Handle the location variables and enable the submit button.
     */
    function setLocation(suggestion) {
      city = suggestion.city;
      state = suggestion.state;
      latitude = suggestion.latitude;
      longitude = suggestion.longitude;

      $submitButton.prop('disabled', city === '');
    }


    /**
     * Collect the data and redirect.
     * 
     * @param {*} event
     */
    function submitForm(event) {
      const citySlug = city.toLowerCase().replace(/ /g,'-');
      const query = {
        c: city,
        s: state,
        movein: $moveInInput.val(),
        moveout: $moveOutInput.val(),
        lat: latitude,
        lng: longitude,
      };
      const queryString = $.param(query);
      
      event.preventDefault();
      window.location = `${searchBaseUrl}${citySlug}?${queryString}`;
    }
  }
);
